import {ProdutoVendido} from "models/Produto";
import React from "react";
import {IonIcon} from "@ionic/react";
import {trashOutline} from "ionicons/icons";
import {formatNumber} from "../../lib/utils";

interface ProdutoVendidoItemProps {
  produto: ProdutoVendido;
  onRemove?: () => void;
}

const ProdutoVendidoItem: React.FC<ProdutoVendidoItemProps> = (props) => {
  const {produto, onRemove} = props;

  return (
    <div className="flex flex-col w-full">
      <div className="flex gap-2 items-baseline text-xs w-full">
        <div className="w-2/12">
          {produto.sku}
        </div>
        <div className="w-10/12 truncate">
          {produto.label}
        </div>
      </div>
      <div className="flex gap-2 items-center text-xs w-full opacity-70">
        <div className="w-2/12">
        {formatNumber(produto.quantidade, 0)} un
        </div>
        <div className="w-10/12 flex items-center">
          <div className="w-4/12">
            R$ {formatNumber(produto.valor)}
          </div>
          <div className="text-right w-6/12">
            R$ {formatNumber(produto.valor! * produto.quantidade)}
          </div>
          
          <div className="flex justify-end w-2/12">
          {onRemove &&
            <div
              className="flex flex-col justify-center cursor-pointer"
              onClick={onRemove}
            >
              <IonIcon icon={trashOutline} className="text-red-600 text-lg"/>
            </div>
          }
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default ProdutoVendidoItem;
